import * as yup from "yup";

export const BudgetSchema = yup.object({
  budgetOutgoings: yup.number().nullable(),
  budgetPromotionLevy: yup.number().nullable(),
  budgetRent: yup.number().nullable(),
  budgetIncentive: yup.number().nullable(),
  budgetLessorworks: yup.number().nullable(),
  budgetMakegood: yup.number().nullable(),
  budgetRentValuation: yup.number().nullable(),
});

export type BudgetType = yup.InferType<typeof BudgetSchema>;
